import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../styles/SubscriptionContainer.module.scss';
import Button from '../../../../components/Button';
import { SubscriptionAppBarSpacer } from '../../components/SubscriptionAppBar';
import { inAppCancellation as events } from '../../../../lib/analytics/events';
import { usePurchaseSubscriptionContext } from '../../../PurchaseSubscription/context/PurchaseSubscriptionContext';

export default function DowngradeS3Confirmed() {
  const { t } = useTranslation();
  const { device } = usePurchaseSubscriptionContext();
  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBarSpacer />
        <div className={styles.subscriptionContainer}>
          <div className={styles.content}>
            <h1>{t('your_plan_has_been_updated')}</h1>

            <p>
              {t(
                'thank_you_for_being_a_fi_member_your_series_3_membership_will_be_billed_as_per_your_new_plan_at_renewal',
              )}
            </p>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            onClick={() => {
              events.downgradeS3ConfirmationDone({ petId: device.pet?.id });
              window.open('fi://closeappview');
            }}
          >
            {t('done')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
